import { useQuery } from '@tanstack/react-query';
import { useVenueProfile } from '@/contexts/VenueProfileContext';
import { queryKeys } from '@/lib/queryKeys';
import { getUserRole, ROLE_CONFIG } from '@/services/roleService';

export function useUserRole() {
  const { profile: venueProfile, isLoading: isProfileLoading } = useVenueProfile();
  const venueId = venueProfile?.id;

  const { data, isLoading: isQueryLoading } = useQuery({
    queryKey: queryKeys.userRole.forVenue(venueId ?? ''),
    queryFn: () => getUserRole(venueId ?? ''),
    enabled: !!venueId,
  });

  // Loading if profile is still loading OR role query is in-flight
  const isLoading = isProfileLoading || (!venueId ? true : isQueryLoading);

  const role = data?.role ?? null;
  const isOwner = data?.isOwner ?? false;
  const isAdmin = role === 'admin' || isOwner;
  const canAccessGMReports = isOwner || (role ? ROLE_CONFIG[role].canAccessGMReports : false);
  const canAccessBilling = isOwner || (role ? ROLE_CONFIG[role].canAccessBilling : false);
  const canManageTeam = isOwner || (role ? ROLE_CONFIG[role].canManageTeam : false);

  return {
    role,
    isOwner,
    isAdmin,
    isLoading,
    canAccessGMReports,
    canAccessBilling,
    canManageTeam,
  };
}
